module.exports = __webpack_public_path__ + "static/media/mstable.43a54a9a.svg";